import { GlobalDataContext } from "@/app/context/global/globalDataContext";
import Header from "@/app/layout/global/header";
import { HStack, Button, Flex, Image, Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, Badge, VStack, ButtonGroup, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { GameFriendsScore } from "@/app/context/friends/layout/gameFriendsScore";
import { AuthenticationContext } from "@/app/context/authentication/authenticationContext";
import { FriendsContext } from "@/app/context/friends/friendsContext";
import { GlobalDataUserContext } from "@/app/context/global/globalDataUserContext";
import MapboxMap from "@/app/layout/map/mapboxMap";
import Footer from "@/app/layout/global/footer";
import MenuContent from "../global/menuContent";
import Skeleton from "../global/skeleton";
import { distanceFormatterHelper, timeFormatterHelper } from "@/app/helpers/numberFormatterHelper";
import { getDistance } from "@/app/helpers/mapHelper";
import { BodyHead } from "../global/bodyHead";
import { RainEffect } from "../game/rainEffect";
import CreaturesGrid from "@/app/context/game/layout/creaturesGrid";
import { GameContext } from "@/app/context/game/gameContext";
import { buildGameUrl } from "@/app/helpers/buildUrlHelper";
import { BiSolidBadgeCheck } from "react-icons/bi";
import { MdLeaderboard } from "react-icons/md";
import { TiStarFullOutline } from "react-icons/ti";
import { SelectQuestDrawer } from "../game/modal/selectQuestDrawer";
import CharacterTalkingQuestModal from "@/app/context/game/layout/modal/characterTalkingQuesModalt";
import {FaChevronDown} from "react-icons/fa";
import CapturePhotoEnvironment from "../game/modal/capturePhotoEnvironment";

export default function ChaseLayout() {

    const {t} = useTranslation();
    const contentRef = useRef<HTMLDivElement|null>(null); 

    const {
        language,
        categoryId,
        location,
        bearing,
        isRaining,
    } = useContext(GlobalDataContext)

    const {
        friendRequestWithUser,
    } = useContext(FriendsContext)
    
    const {
        user,
    } = useContext(AuthenticationContext)
    
    const {
        myZones,
        play
    } = useContext(GlobalDataUserContext)

    const {
        mapRef,
        chase,
        insideZone,
        isDarkMode,
        closeToMonster,
        startGame,
        renderPolygons,
        checkZones,
        doResize,
        gotBonus,
        setUseBonus,
        elapsedTime,
        setDoResize
    } = useContext(GameContext)

    const [openIndex, setOpenIndex] = useState<number | number[] | null>(null);

    const {isOpen, onOpen, onClose} = useDisclosure()
    const {isOpen: isOpenZoneAround, onOpen: onOpenZoneAround, onClose: onCloseZoneAround} = useDisclosure()

    const useBonus=()=>{
        setUseBonus(true)
        play("ding01")
    }
    
    useEffect(()=>{
        setDoResize(true)
    },[])
      
    const zonesWithinRange = useMemo(() => {
        return myZones
          ?.map((zone) => ({
            ...zone,
            distance: getDistance(
              { latitude: location?location.lat:zone.coords[0].lat, longitude: location?location.lng:zone.coords[0].lng },
              { latitude: zone.coords[0]?.lat, longitude: zone.coords[0]?.lng },
              1
            ),
          }))
          .filter((zone) => zone.distance <= 5000)
          .sort((a, b) => a.distance - b.distance);
      }, [myZones, location]);


      // Gérer l'ouverture automatique basé sur la condition `insideZone`
    useEffect(() => {
        const autoOpenIndex = zonesWithinRange.findIndex((zone: any) => zone.id === insideZone);
        if (autoOpenIndex !== -1) {
        setOpenIndex(autoOpenIndex); // Ouvre automatiquement l'élément correspondant
        }
    }, [insideZone, zonesWithinRange]);

    // Fonction pour gérer l'ouverture manuelle
    const handleAccordionChange = (index: number | number[] | null) => {
        if (Array.isArray(index)) {
            setOpenIndex(index.length > 0 ? index[0] : null); // Si plusieurs sont ouverts, on prend le premier
          } else {
            setOpenIndex(index);
          }
    };

    return (
        <>
        <BodyHead
                url={process.env.NEXT_PUBLIC_URL as string}
                mainTitle={t("home.title")}
                title={t("home.titleBody")}
                description={t("home.descriptionBody")}
            />
        <Skeleton
            background={<CreaturesGrid chase={chase}/>}
            header={<Header title={t("game.explore")} confirmQuitPage={chase.status=="started"?true:false} allowBackButton urlBack={buildGameUrl(language, categoryId, undefined)}/>}        
            menu={<MenuContent/>}
            footer={<Footer background={(chase.status=="started" && !insideZone)?"red":undefined}>
                {chase.status=="pending" && insideZone && 
                <ButtonGroup margin="auto"variant='solid' size="lg" borderRadius="50px" isAttached >
                    <Button onClick={()=>startGame()} style={{ animation: insideZone? "bounce 1s ease-in infinite": ""}} borderRadius="50px!important" background={insideZone?"#f16529!important":"grey!important"} opacity={insideZone?"1":"0.3"} className="mainButton" color="white!important" >
                        {t("game.play")}
                    </Button>
                </ButtonGroup>
                }
                {chase.status=="pending" && !insideZone && 
                    <CapturePhotoEnvironment/>
                }
                {(chase.status=="started") && gotBonus && 
                    <Flex zIndex={5} onClick={useBonus} position="absolute" bottom="1" bg="#0d547d52" borderRadius="50%" left="3">
                        <Flex position="relative" w="54px" h="54px" border="4px solid white" borderRadius={"50%"}>                            
                            <TiStarFullOutline
                            color={"#ffbf00"}
                            className="bonus "
                            style={{ position: "absolute", top:0, left:0, fontSize: "45px", zIndex: 10, margin: "auto" }}
                            />
                        </Flex>
                    </Flex>}
                    {(chase.status=="started" && !insideZone ) && <Flex zIndex={3} position="absolute" top="0" left="0" w="full" h="full"  fontWeight={"bold"}><Text alignContent="end" textAlign={"center"} color="black" pb={5} fontSize="2em" w="full">{t("game.outOfZone")}</Text></Flex>}
                    {chase.status=="started" && <Flex zIndex={2} overflow="hidden" position="absolute" placeContent="center" bottom="0" left="0" w="full" h="200px">
                        <Box position="absolute" bottom="10" w="130px" h="130px">
                            <Image position="absolute" bottom="0" transition="rotate 2s ease-in-out;" className={"sonar " + (closeToMonster?" close ":"")} borderRadius={"50%"} alt="scanner" w="130px" h="130px" margin="auto" border="3px solid gray" borderTopColor="#4b4848" borderLeftColor="#4b4848" src="/images/scanner.png" />
                            <Box zIndex="5" position="absolute" marginBottom="65px" bottom="0" w="65px" h="65px" className="sweep"/>
                            {closeToMonster && <Box className="radar-pulse"></Box>}
                        </Box> </Flex>}
                </Footer>  }
            friends={<>{user && user.email && <GameFriendsScore friends={friendRequestWithUser}/> }</>}
        >            
            <Flex position="relative" w="full" h="full" flexDir={"column"}>
                
                {(chase.status=="started") && 
                    <Flex zIndex={3} overflow="hidden" position="absolute" placeContent="center" top="0" left="0" w="full" h="200px">
                        <Box position="absolute" top="100px" px={3} py={2} bg={isDarkMode?"black":"white"} color={isDarkMode?"white":"black"}>
                            <Text fontSize="3em" fontFamily={"'DigitalClock','Orbitron', sans-serif"}>{timeFormatterHelper(elapsedTime,0)}</Text>
                        </Box>                                                  
                    </Flex>}
                {(chase.status=="started") && isRaining && <RainEffect isNight={isDarkMode} />}
                {(chase.status=="started" || chase.status=="finished") &&<CreaturesGrid chase={chase}/>}
                <MapboxMap  
                    handleMoveEnd={checkZones}
                    handleZoomEnd={checkZones}
                    handleLoaded={checkZones}
                    mapRef={mapRef} 
                    mapContent={renderPolygons()} 
                    pitch={chase.status=="started"?70:0}
                    forceZoom={chase.status=="started"?true:false}
                    doResize={doResize}/>
                {chase.status=="pending" && myZones && location && myZones.length && <Flex position="absolute"   maxH="40%" top="2" left="2"> 
                    <Flex zIndex="12" flexDirection="column" borderRadius={5} border={isDarkMode?"1px solid #FFFFFF17":"1px solid #00000017"} w="220px" background={isDarkMode?"#89848433":"#ffffff33"} backdropFilter="blur(5px)" >               
                    <HStack 
                        onClick={isOpenZoneAround?onCloseZoneAround:onOpenZoneAround}
                        bg={isDarkMode?"#00000057":"white"} color={isDarkMode?"white":"black"} px={2} py={2}>
                        <Text w='full'>{t("zone.zonesAround")} <small>({myZones.length})</small></Text>
                        <FaChevronDown style={{
                            transform: `rotate(${isOpenZoneAround ? 180 : 0}deg)`,
                            transition: "transform 0.3s ease",
                        }}/>
                    </HStack>
                    <Accordion 
                        ref={contentRef}
                        h={isOpenZoneAround?`${contentRef.current?.scrollHeight}px`:"0"}
                        transition={"height 0.5s ease"}
                        allowToggle  
                        overflowY="auto"  >
                    {zonesWithinRange
                    .map((zone:any, index) => (
                        <AccordionItem key={index} borderColor={isDarkMode?"black":"white"}>
                            <h2>
                                <AccordionButton py={1} px={2}>
                                    <Flex
                                        fontSize={"sm"}
                                        w="full"
                                        textAlign={"left"}
                                    >
                                        <Text alignItems="center" display="flex" color={isDarkMode?"white":"black"} w="full">{zone.name} {zone.leaderboard && <MdLeaderboard style= {{paddingLeft: 2}}/>} {zone.ownerId!=="generic" &&<BiSolidBadgeCheck color="darkcyan" style= {{paddingLeft: 2}}/>}</Text>
                                        {location && (
                                            <Badge
                                                color="#242323a1"
                                                background={zone.distance <= 1000
                                                    ? "#c9de91"
                                                    : zone.distance <= 2500
                                                    ? "#ffd27e"
                                                    : "#ff8a8a"}
                                                textTransform={"none"}
                                            >
                                                {distanceFormatterHelper(
                                                    zone.distance,
                                                    1
                                                )}
                                            </Badge>
                                        )}
                                    </Flex>
                                </AccordionButton>
                            </h2>
                            <AccordionPanel p={2} bg={isDarkMode?"#00000091":"#bdbdbd"} color={isDarkMode?"white":"black"}>
                                <Text fontSize="sm" fontWeight="bold">{t("game.leaderboard")}</Text>
                                {zone.leaderboard && zone.leaderboard.length > 0 && zone.leaderboard.map((leader:any, index:number) => (    
                                    <Flex key={index} alignItems="center" py={1} background={index % 2 != 0?"#bdbdbd26":"transparent"}>                                        
                                        <Image borderRadius={"50%"} w="30px" h="30px" src={leader.userPhotoUrl} alt={leader.userName} />
                                        <VStack  alignItems="flex-start" px={2} gap={0} w="full">
                                            <Text fontSize={"sm"} textOverflow="ellipsis" overflow=" hidden" whiteSpace="nowrap" lineHeight="1em" fontWeight={"bold"}>{leader.userName}</Text>
                                            <Text fontSize={"sm"}>{timeFormatterHelper(Math.floor(leader.timestamp/1000),0)}</Text>
                                        </VStack>
                                        <Badge bg="#2a9ce1" fontSize="lg" lineHeight="0.8em" color="white" borderRadius={"50%"} p={2} minW="30px" textAlign="center" h="30px">{index+1}</Badge>
                                    </Flex> 
                                ))}
                                {!(zone.leaderboard && zone.leaderboard.length > 0) && zone.ownerId!=="generic" && 
                                    <Text fontSize="sm">{t("game.noLeaderboard")}</Text>
                                }
                                {!(zone.leaderboard && zone.leaderboard.length > 0) && zone.ownerId=="generic" && 
                                    <Text fontSize="sm">{t("game.leaderboardUnavailable")}</Text>
                                }
                            </AccordionPanel>
                        </AccordionItem>
                    ))}
                    </Accordion>
                    </Flex>    
                </Flex>}
                <SelectQuestDrawer isOpen={isOpen} onClose={onClose}/>
            </Flex>
        </Skeleton>
        </>
    )

}
